import React from 'react';
import { variables } from 'src/Tenants';
import Col from 'src/components/Col';
import Row from 'src/components/Row';
import Diagnosis from 'src/components/Diagnosis/Diagnosis';
import Input from 'src/components/Input';
import Textarea from 'src/components/Textarea';

export interface DetailsInfoFieldsProps {
  diagnosisAsset: string;
  diagnosisIssueType: string;
  warrantyExpiresAt: string;
  propertyName: string;
  suiteNumber: string;
  descriptionPlaceholder: string;
  description: string;
  onChangeDescription: (value: string) => void;
}

const DetailsInfoFields = ({
  diagnosisAsset,
  diagnosisIssueType,
  warrantyExpiresAt,
  propertyName,
  suiteNumber,
  descriptionPlaceholder,
  description,
  onChangeDescription,
}: DetailsInfoFieldsProps) => {
  return (
    <div className="details-info-fields">
      <Diagnosis
        asset={diagnosisAsset}
        issueType={diagnosisIssueType}
        expiresAt={warrantyExpiresAt}
        location={undefined}
        label={undefined}
      />
      <Row>
        <Col xs="12" md="6">
          <Input label="Property" value={propertyName} disabled block />
        </Col>
        <Col xs="12" md="6">
          <Input label={variables.Suite} value={suiteNumber} disabled block />
        </Col>
      </Row>
      <Textarea
        required
        label="Description"
        placeholder={descriptionPlaceholder}
        onChange={(e: any) => onChangeDescription(e.target.value)}
        value={description}
        block
      />
    </div>
  );
};

export default DetailsInfoFields;